import { TouchPointHelper } from '../../../helpers/touchPointHelper';
import { placeholders, displayGroups } from '@ui';

export const integratedSolutionResumeAndAuthorization = {
	prismName: 'integratedSolutionResumeAndAuthorization',
	template: {
		templateName: 'integratedSolutionResumeAndAuthorizationTemplate',
		displayGroups: [
			TouchPointHelper.createDisplayGroup(displayGroups.pageContainer, [
				TouchPointHelper.createDisplayGroup(displayGroups.rowContainer, [
					TouchPointHelper.createDisplayGroup(
						displayGroups.leftPanel,
						[],
						[
							TouchPointHelper.createPlaceholder(placeholders.logoBcp, {
								placeholderBuildReference: 10,
							}),
							TouchPointHelper.createPlaceholder(placeholders.wizardMenu, {
								placeholderBuildReference: 100,
							}),
							TouchPointHelper.createPlaceholder(placeholders.doubtsAndExit, {
								placeholderBuildReference: 200,
							}),
						]
					),
					TouchPointHelper.createDisplayGroup(
						displayGroups.columnContainer,
						[
							TouchPointHelper.createDisplayGroup(
								displayGroups.bodyPanel,
								[],
								[
									TouchPointHelper.createPlaceholder(placeholders.costSummary, {
										placeholderBuildReference: 500,
									}),
									TouchPointHelper.createPlaceholder(placeholders.bankDocument, {
										placeholderBuildReference: 501,
									}),
									TouchPointHelper.createPlaceholder(placeholders.personalAccidentInsurance, {
										placeholderBuildReference: 502,
									}),
									TouchPointHelper.createPlaceholder(placeholders.establishmentAssistanceInsurance, {
										placeholderBuildReference: 503,
									}),
								]
							),
						],
						[
							TouchPointHelper.createPlaceholder(placeholders.authenticatorFooter, {
								placeholderBuildReference: 1000,
							}),
							TouchPointHelper.createPlaceholder(placeholders.modals, {
								placeholderBuildReference: 1001,
							}),
						]
					),
				]),
			]),
		],
	},
};
